module.exports = __webpack_public_path__ + "img/head1.ed67342e.png";